import {FC, MouseEventHandler} from 'react';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {WorldIcon} from '~library/svg/v2/WorldIcon';

interface TimezoneDisplayProps {
  timezone: Timezone | null;
  openTimezoneSelector: MouseEventHandler<HTMLButtonElement>;
  qaIdPrefix?: string;
}

export const TimezoneDisplay: FC<TimezoneDisplayProps> = ({
  timezone: tz,
  openTimezoneSelector,
  qaIdPrefix = 'event',
}) => (
  <Button
    variant="unstyled-button"
    className="start-end-controller__timezone-display"
    onClick={openTimezoneSelector}
    data-qa-id={`${qaIdPrefix}-timezone`}
    aria-label="Event time zone"
  >
    <WorldIcon ratio={0.5} />
    <div className="start-end-controller__timezone-display__details">
      {tz ? (
        <Typography
          variant="paragraph3"
          semibold
          className="start-end-controller__timezone-display-text"
        >
          {tz.timezone_abbr} - {tz.timezone_display_name.split(' ').slice(1).join(' ')}
        </Typography>
      ) : null}
      <Typography variant="paragraph3" as="span" semibold color="tanzanite">
        {tz ? 'Change' : 'Select timezone'}
      </Typography>
    </div>
  </Button>
);
